import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import { Feature } from 'src/replicant/analytics';
import PopupMatch2Base from '../components/PopupMatch2Base';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver, { user, now } from 'src/StateObserver';
import {
  createUiTournamentHeader,
  getInfoPopupTitleLayout,
  getTournamentHeroImage,
  getTournamentTitleImage,
  isFlyingHighRedesignTournament,
} from './match2-tournament.utils';
import * as match2TournamentGetters from 'src/replicant/match2/tournament/match2-tournament.getters';
import { AssetGroup } from '@play-co/timestep-core';

export default class PopupMatch2TournamentInfo extends PopupMatch2Base {
  constructor(opts: { superview: View; close: (success: boolean) => void }) {
    const locale = StateObserver.getLocale() === 'en' ? 'en' : 'ja';
    const event = match2TournamentGetters.getTournamentPeriod(user(), now());
    const type = event?.type ?? 'star';
    const titleLayout = getInfoPopupTitleLayout(type, locale);

    super({
      superview: opts.superview,
      panelImageOpts: {
        image: 'assets/ui/match2/common/panel_intro.png',
        width: 588,
        height: 859,
        scaleMethod: 'contain',
      },
      offsetY: -140,
      close: () => opts.close(false),
      title: {
        type: 'image',
        opts: {
          scaleMethod: 'contain',
          canHandleEvents: false,
          image: getTournamentTitleImage(type, locale),
          width: titleLayout.width,
          height: titleLayout.height,
          y: 10,
        },
      },
      cta: {
        localeText: () => i18n('match2.tournament.play').toLocaleUpperCase(),
        onClick: () => opts.close(true),
        positioning: 'inside',
      },
      tracking: {
        feature: Feature.MATCH2.TOURNAMENT._,
        $subFeature: Feature.MATCH2.TOURNAMENT.POPUP,
      },
    });

    createUiTournamentHeader(
      this.panelView,
      type,
      this.panel.style.width * 0.5,
      -80,
    );

    new LangBitmapFontTextView({
      superview: this.panel,
      x: this.panel.style.width * 0.5,
      y: this.panel.style.height - 195,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 30,
      font: 'Body',
      width: this.panel.style.width * 0.85,
      height: 100,
      color: '#BF8147',
      localeText: () => i18n(`match2.tournament.info_${type}`),
    });

    new ImageScaleView({
      superview: this.panelView,
      image: getTournamentHeroImage(type),
      width: 500,
      height: 500,
      x: this.panel.style.width * 0.5 - 1,
      y: 335,
      scaleMethod: 'contain',
      centerOnOrigin: true,
      zIndex: -1,
    });
  }

  protected getAssetsGroup() {
    // Tournament assets are not organised by type, so we load the whole folder.
    const event = match2TournamentGetters.getTournamentPeriod(user(), now());
    const assetPaths = [`assets/ui/match2/tournament`];
    if (isFlyingHighRedesignTournament(event?.type ?? 'star')) {
      assetPaths.push(`assets/ui/match2/tournament/flyinghigh`);
    }
    const urls = AssetGroup.constructURLs(assetPaths);
    return new AssetGroup(urls);
  }
}
